// Qual pacote esta visita carrega: o do SITE (landing + privacidade) ou o do APP inteiro.
//
// ═════════════════════════════════════════════════════════════════════════════
// ⚠️ A LANDING BAIXAVA O SISTEMA INTEIRO. Um pacote só, de ~2,7 MB, com as 76 telas do
// app: num 4G fraco a página ficava em branco até tudo chegar (avaliação de 30/09/2026).
// Agora a entrada (index.js) escolhe ANTES de carregar: quem abre o site baixa só a
// landing; quem abre o app baixa o app.
//
// A regra é a mesma da PortaDeEntrada, e precisa continuar sendo:
//   · porta do app (app.cresceja.com.br) → app, sempre;
//   · página do site ("/", "/privacidade") → site;
//   · exceto em desenvolvimento (localhost) com sessão válida: aí "/" é o inbox.
// Qualquer outro caminho é tela do sistema → app.
// ═════════════════════════════════════════════════════════════════════════════
import { PAGINAS_DO_SITE, ehPortaDoApp, ehLocal } from "./dominios";
import { sessaoValida } from "./sessao";

export function abreSoOSite({ hostname = "", pathname = "/", token = null } = {}) {
  if (ehPortaDoApp(hostname)) return false;
  const caminho = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  if (!PAGINAS_DO_SITE.includes(caminho)) return false;
  if (ehLocal(hostname) && sessaoValida(token)) return false;
  return true;
}
